import React, { Component } from "react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import { Button, Card, Form, Icon } from "semantic-ui-react";

const defaultImages = [
  "https://s3.amazonaws.com/bsc-platform-content/images/scs.png",
  "https://s3.amazonaws.com/bsc-platform-content/images/trial.png",
  "https://s3.amazonaws.com/bsc-platform-content/images/faq.png",
  "https://s3.amazonaws.com/bsc-platform-content/images/stories.png"
];
class CategoryForm extends Component {
  state = {
    input: {
      name: "",
      iconUrl: "",
      description: ""
    },
    images: defaultImages
  };
  handleChange = (event, { name, value }) => {
    this.setState(state => {
      return { input: { ...state.input, [name]: value } };
    });
  };
  handleToggleVisible = () => {
    this.setState(state => {
      return { input: { ...state.input, visible: !state.input.visible } };
    });
  };
  handleSubmit = () => {
    let { input } = this.state;
    if (typeof input.iconUrl !== "string") {
      this.uploadImage(input.iconUrl.file).then(({ data }) => {
        this.props
          .submit({ ...input, iconUrl: data.uploadFile.url })
          .then(this.props.hide);
      });
    } else {
      this.props.submit(input).then(this.props.hide);
    }
  };
  handleCancel = event => {
    event.preventDefault();
    this.props.hide();
  };
  handleSelectImage = (event, { value }) => {
    event.preventDefault();
    this.setState(state => ({
      input: { ...state.input, iconUrl: value }
    }));
  };
  openFilePicker = event => {
    event.preventDefault();
    this.filePicker.click();
  };
  uploadImage = file => {
    return this.props.client.mutate({
      mutation: UPLOAD_FILE_MUTATION,
      variables: { file }
    });
  };
  addImage = event => {
    event.preventDefault();
    const image = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = e => {
      const img = new Image(60, 60);
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 60;
        canvas.height = 60;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, 60, 60);
        const imageDataUrl = canvas.toDataURL("image/png");
        canvas.toBlob(blob => {
          const newImage = {
            src: imageDataUrl,
            file: new File([blob], image.name.split(".")[0] + ".png")
          };
          this.setState(state => ({
            images: [...state.images, newImage],
            input: { ...state.input, iconUrl: newImage }
          }));
        });
      };
    };
  };

  componentDidMount() {
    if (this.props.initialValues) {
      const images = defaultImages.includes(this.props.initialValues.iconUrl)
        ? defaultImages
        : [this.props.initialValues.iconUrl, ...defaultImages];
      this.setState(state => ({
        input: { ...state.input, ...this.props.initialValues },
        images
      }));
    } else {
      this.setState(state => ({
        input: {
          ...state.input,
        }
      }));
    }
  }

  render() {
    return (
      <Card>
        <div style={{ padding: "1rem 2rem" }}>
          <Form onSubmit={this.handleSubmit}>
            <Form.Input
              label="Name"
              name="name"
              id="name-input"
              value={this.state.input.name}
              onChange={this.handleChange}
            />
            <h5>Select or upload an image</h5>
            {this.state.images.map(image => {
              return (
                <Button
                  key={
                    typeof image === "string"
                      ? image.split("/").slice(-1)[0]
                      : image.file.name
                  }
                  active={this.state.input.iconUrl === image}
                  primary
                  basic
                  inverted
                  value={image}
                  onClick={this.handleSelectImage}
                >
                  <img src={typeof image === "string" ? image : image.src} />
                </Button>
              );
            })}
            <Form.Input type="file" accept="image/*" onChange={this.addImage}>
              <Button primary basic inverted onClick={this.openFilePicker}>
                <div
                  style={{
                    height: 60,
                    width: 60,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Icon name="plus" color="blue" />
                </div>
              </Button>
              <input
                ref={element => (this.filePicker = element)}
                style={{ display: "none" }}
              />
            </Form.Input>

            <Form.Input
              label="Description"
              name="description"
              id="description-input"
              value={this.state.input.description}
              onChange={this.handleChange}
            />
            <Button primary type="submit" loading={this.props.loading}>
              {this.props.initialValues ? "Update Category" : "Create Category"}
            </Button>
            <Button onClick={this.handleCancel}>Cancel</Button>
          </Form>
        </div>
      </Card>
    );
  }
}
const UPLOAD_FILE_MUTATION = gql`
  mutation UploadFile($file: Upload!) {
    uploadFile(file: $file) {
      url
    }
  }
`;
export default withApollo(CategoryForm);



// WEBPACK FOOTER //
// ./src/pages/Categories/CategoryForm.js